module.exports = __webpack_public_path__ + "media/sprites.d0b6091e.mp3";